import type { CheckoutSessionDTO } from './checkoutApi.js';

/** G30 — resolve sales point for capability fetch (API column, legacy kioskId, or metadata shop). */
export function resolveCheckoutSalesPointId(
  session:
    | (Pick<CheckoutSessionDTO, 'salesPointId' | 'kioskId'> & {
        metadataShopSalesPointId?: number | null;
      })
    | null
): number | null {
  if (session === null) {
    return null;
  }
  if (
    session.salesPointId !== null &&
    session.salesPointId !== undefined &&
    session.salesPointId > 0
  ) {
    return session.salesPointId;
  }
  if (session.kioskId !== null && session.kioskId !== undefined && session.kioskId > 0) {
    return session.kioskId;
  }
  const metadataShopId = session.metadataShopSalesPointId;
  if (metadataShopId !== null && metadataShopId !== undefined && metadataShopId > 0) {
    return metadataShopId;
  }
  return null;
}

export function resolveMetadataShopSalesPointId(
  metadata: Record<string, unknown> | null | undefined
): number | null {
  if (metadata === null || metadata === undefined) {
    return null;
  }
  const shop = metadata['shop'];
  if (shop === null || typeof shop !== 'object') {
    return null;
  }
  const salesPointId = (shop as { salesPointId?: unknown }).salesPointId;
  if (typeof salesPointId === 'number' && salesPointId > 0) {
    return salesPointId;
  }
  return null;
}

export function resolveCheckoutSalesPointIdFromSession(
  session: CheckoutSessionDTO | null,
  metadata?: Record<string, unknown> | null
): number | null {
  if (session === null) {
    return null;
  }
  return resolveCheckoutSalesPointId({
    salesPointId: session.salesPointId ?? null,
    kioskId: session.kioskId,
    metadataShopSalesPointId: resolveMetadataShopSalesPointId(metadata ?? null),
  });
}
